import { shouldPolyfill as shouldPolyfillNumber } from '@formatjs/intl-numberformat/should-polyfill';
import { shouldPolyfill as shouldPolyfillDate } from '@formatjs/intl-datetimeformat/should-polyfill';
import { shouldPolyfill as shouldPolyfillPlural } from '@formatjs/intl-pluralrules/should-polyfill';
import { shouldPolyfill as shouldPolyfillRelativeTime } from '@formatjs/intl-relativetimeformat/should-polyfill';

export default async (locale) => {
  if (shouldPolyfillNumber(locale)) {
    await import('@formatjs/intl-numberformat/polyfill-force');
    await import('@formatjs/intl-numberformat/locale-data/es-MX');
  }

  if (shouldPolyfillDate(locale)) {
    await import('@formatjs/intl-datetimeformat/polyfill-force');
    const dataPolyfills = [
      import('@formatjs/intl-datetimeformat/locale-data/es-MX'),
    ];
    await Promise.all(dataPolyfills);
  }

  if (shouldPolyfillPlural(locale)) {
    await import('@formatjs/intl-pluralrules/polyfill-force');
    await import('@formatjs/intl-pluralrules/locale-data/es');
  }

  if (shouldPolyfillRelativeTime(locale)) {
    await import('@formatjs/intl-relativetimeformat/polyfill');
    await import('@formatjs/intl-relativetimeformat/locale-data/es');
  }
};
